import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getLinkExpiredPath = () => urlHelper(`/auth/link-expired`);
